import { DEFAULT_TOTAL_RECORDS } from "utils/constants";
import zoneLocalStorageId from "utils/zone";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchZone = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
  return axiosInstance.get(EndPoints.Zone.LIST, {
    params: {
      limit,
      page_no,
      zone_id: zoneLocalStorageId(),
      ...filter,
      // total_count:totalItems
    },
  });
};

export const fetchZoneById = (id) => {
  return axiosInstance.get(`${EndPoints.Zone.LIST_BY_ID}/${id}`);
};

export const createZone = (payload) => {
  return axiosInstance.post(EndPoints.Zone.CREATE, payload);
};

export const updateZone = (payload) => {
  return axiosInstance.put(EndPoints.Zone.UPDATE, payload);
};

export const deleteZone = (payload) => {
  const url = EndPoints.Zone.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const fetchZoneLogoById = (id) => {
  return axiosInstance.get(`${EndPoints.Zone.ZONE_LOGO_BY_ID}?id=${id}`);
};

export const fetchZoneLogoBase64 = async (id) => {
  if (!id) return "";
  const response = await fetchZoneLogoById(id);
  const body = response?.data;
  const logo =
    body?.file_data ||
    body?.logo_data ||
    body?.zone_logo ||
    body?.logo ||
    body?.data ||
    body;
  return typeof logo === "string" ? logo : "";
};

export const downloadZoneCSV = () => {
  return axiosInstance.put(EndPoints.Zone.DOWNLOAD_CSV, {
    responseType: "blob",
  });
};
